/**
 * Official streaming platform metadata, branding, presets, and logo definitions.
 */

export const STREAMING_PLATFORMS = [
  {
    id: "netflix",
    name: "Netflix",
    shortName: "Netflix",
    badgeBg: "bg-[#E50914] hover:bg-[#b80710] text-white border-[#E50914]/40",
    color: "#E50914",
    defaultUrl: "https://www.netflix.com",
    aliases: ["netflix", "netflix basic with ads", "netflix kids"],
    logoType: "netflix"
  },
  {
    id: "prime",
    name: "Prime Video",
    shortName: "Prime",
    badgeBg: "bg-[#00A8E1] hover:bg-[#008cc0] text-white border-[#00A8E1]/40",
    color: "#00A8E1",
    defaultUrl: "https://www.primevideo.com",
    aliases: ["amazon prime video", "amazon video", "prime video", "amazon prime"],
    logoType: "prime"
  },
  {
    id: "disney",
    name: "Disney+",
    shortName: "Disney+",
    badgeBg: "bg-[#113CCF] hover:bg-[#0d2fa3] text-white border-[#113CCF]/40",
    color: "#113CCF",
    defaultUrl: "https://www.disneyplus.com",
    aliases: ["disney plus", "disney+", "disneyplus"],
    logoType: "disney"
  },
  {
    id: "max",
    name: "Max",
    shortName: "Max",
    badgeBg: "bg-[#002BE7] hover:bg-[#0022b8] text-white border-[#002BE7]/40",
    color: "#002BE7",
    defaultUrl: "https://www.max.com",
    aliases: ["max", "hbo max", "hbo", "hbomax", "hbo max amazon channel"],
    logoType: "max"
  },
  {
    id: "apple",
    name: "Apple TV+",
    shortName: "Apple TV+",
    badgeBg: "bg-zinc-900 hover:bg-zinc-800 text-white border-white/20",
    color: "#FFFFFF",
    defaultUrl: "https://tv.apple.com",
    aliases: ["apple tv", "apple tv plus", "apple tv+", "itunes"],
    logoType: "apple"
  },
  {
    id: "filmin",
    name: "Filmin",
    shortName: "Filmin",
    badgeBg: "bg-[#00D09C] hover:bg-[#00b386] text-black border-[#00D09C]/40 font-bold",
    color: "#00D09C",
    defaultUrl: "https://www.filmin.es",
    aliases: ["filmin", "filmin plus"],
    logoType: "filmin"
  },
  {
    id: "mubi",
    name: "MUBI",
    shortName: "MUBI",
    badgeBg: "bg-black hover:bg-zinc-900 text-white border-white/30",
    color: "#FFFFFF",
    defaultUrl: "https://mubi.com",
    aliases: ["mubi", "mubi amazon channel"],
    logoType: "mubi"
  },
  {
    id: "paramount",
    name: "Paramount+",
    shortName: "Paramount+",
    badgeBg: "bg-[#0064FF] hover:bg-[#0050cc] text-white border-[#0064FF]/40",
    color: "#0064FF",
    defaultUrl: "https://www.paramountplus.com",
    aliases: ["paramount plus", "paramount+", "paramount+ amazon channel"],
    logoType: "paramount"
  },
  {
    id: "movistar",
    name: "Movistar Plus+",
    shortName: "Movistar+",
    badgeBg: "bg-[#0B2265] hover:bg-[#071644] text-[#00A9E0] border-[#00A9E0]/40",
    color: "#00A9E0",
    defaultUrl: "https://ver.movistarplus.es",
    aliases: ["movistar plus+", "movistar plus", "movistar play", "movistar"],
    logoType: "movistar"
  },
  {
    id: "skyshowtime",
    name: "SkyShowtime",
    shortName: "SkyShowtime",
    badgeBg: "bg-gradient-to-r from-[#4A00E0] to-[#8E2DE2] hover:opacity-90 text-white border-white/20",
    color: "#8E2DE2",
    defaultUrl: "https://www.skyshowtime.com",
    aliases: ["skyshowtime", "sky showtime"],
    logoType: "skyshowtime"
  },
  {
    id: "youtube",
    name: "YouTube",
    shortName: "YouTube",
    badgeBg: "bg-[#FF0000] hover:bg-[#d40000] text-white border-[#FF0000]/40",
    color: "#FF0000",
    defaultUrl: "https://www.youtube.com",
    aliases: ["youtube", "youtube premium", "youtube movies"],
    logoType: "youtube"
  },
  {
    id: "googleplay",
    name: "Google Play / TV",
    shortName: "Google Play",
    badgeBg: "bg-[#01875F] hover:bg-[#016849] text-white border-[#01875F]/40",
    color: "#01875F",
    defaultUrl: "https://play.google.com/store/movies",
    aliases: ["google play movies", "google play", "google tv"],
    logoType: "googleplay"
  },
  {
    id: "plutotv",
    name: "Pluto TV",
    shortName: "Pluto TV",
    badgeBg: "bg-black hover:bg-zinc-900 text-yellow-300 border-yellow-400/40",
    color: "#FFFF00",
    defaultUrl: "https://pluto.tv",
    aliases: ["pluto tv", "plutotv"],
    logoType: "plutotv"
  },
  {
    id: "vix",
    name: "ViX",
    shortName: "ViX",
    badgeBg: "bg-[#FF5A00] hover:bg-[#e04f00] text-white border-[#FF5A00]/40",
    color: "#FF5A00",
    defaultUrl: "https://vix.com",
    aliases: ["vix", "vix premium", "vix+"],
    logoType: "vix"
  },
  {
    id: "rtve",
    name: "RTVE Play",
    shortName: "RTVE Play",
    badgeBg: "bg-[#00479E] hover:bg-[#00387d] text-white border-[#0084FF]/40",
    color: "#0084FF",
    defaultUrl: "https://www.rtve.es/play",
    aliases: ["rtve play", "rtve", "playz"],
    logoType: "rtve"
  },
  {
    id: "atresplayer",
    name: "Atresplayer",
    shortName: "Atresplayer",
    badgeBg: "bg-[#1B1B1B] hover:bg-black text-[#FA4616] border-[#FA4616]/40",
    color: "#FA4616",
    defaultUrl: "https://www.atresplayer.com",
    aliases: ["atresplayer", "atres player", "atresplayer premium"],
    logoType: "atresplayer"
  },
  {
    id: "fandango",
    name: "Fandango at Home",
    shortName: "Fandango",
    badgeBg: "bg-[#FA5000] hover:bg-[#d44300] text-white border-[#FA5000]/40",
    color: "#FA5000",
    defaultUrl: "https://www.vudu.com",
    aliases: ["fandango at home", "fandangoathome", "vudu", "fandangonow"],
    logoType: "fandango"
  },
  {
    id: "plex",
    name: "Plex",
    shortName: "Plex",
    badgeBg: "bg-black hover:bg-zinc-900 text-[#E5A00D] border-[#E5A00D]/40 font-bold",
    color: "#E5A00D",
    defaultUrl: "https://www.plex.tv",
    aliases: ["plex", "plex live tv"],
    logoType: "plex"
  },
  {
    id: "tubi",
    name: "Tubi",
    shortName: "Tubi",
    badgeBg: "bg-[#FA3200] hover:bg-[#d82a00] text-white border-[#FA3200]/40",
    color: "#FA3200",
    defaultUrl: "https://tubitv.com",
    aliases: ["tubi", "tubi tv"],
    logoType: "tubi"
  },
  {
    id: "hulu",
    name: "Hulu",
    shortName: "Hulu",
    badgeBg: "bg-[#1CE783] hover:bg-[#18c770] text-black border-[#1CE783]/40 font-bold",
    color: "#1CE783",
    defaultUrl: "https://www.hulu.com",
    aliases: ["hulu", "hulu plus"],
    logoType: "hulu"
  },
  {
    id: "clarovideo",
    name: "Claro Video",
    shortName: "Claro Video",
    badgeBg: "bg-[#E02B20] hover:bg-[#bf241b] text-white border-[#E02B20]/40",
    color: "#E02B20",
    defaultUrl: "https://www.clarovideo.com",
    aliases: ["claro video", "clarovideo"],
    logoType: "clarovideo"
  }
];

export function findPlatformInfo(nameOrId) {
  if (!nameOrId) return null;
  const raw = String(nameOrId).trim().toLowerCase();

  // 1. Direct ID match
  const byId = STREAMING_PLATFORMS.find((p) => p.id === raw);
  if (byId) return byId;

  // 2. Exact name or alias match
  const byExact = STREAMING_PLATFORMS.find((p) =>
    p.name.toLowerCase() === raw ||
    p.aliases.some((a) => a === raw)
  );
  if (byExact) return byExact;

  // 3. Partial alias or substring match
  const byAlias = STREAMING_PLATFORMS.find((p) =>
    p.aliases.some((a) => raw.includes(a) || a.includes(raw)) ||
    raw.includes(p.name.toLowerCase())
  );
  if (byAlias) return byAlias;

  // 4. Fallback for custom platforms
  return {
    id: `custom-${raw.replace(/[^a-z0-9]/g, "-")}`,
    name: nameOrId,
    shortName: nameOrId,
    badgeBg: "bg-zinc-900 hover:bg-zinc-800 text-white border-white/20",
    color: "#E11D48",
    defaultUrl: "",
    aliases: [raw],
    logoType: "custom"
  };
}
